import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'react-toastify/dist/ReactToastify.css';
import { Route, Routes } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SignIn from './components/Layout/Login';
import Protected from './Protected';
import Dashboard from './components/Dashboard/Dashboard';
import ChangePassword from './components/UserSection/ChangePassword/ChangePassword';
import ResetPassword from './components/UserSection/ResetPassword/ResetPassword';
import { PageNotFound } from './components/Common/Common';
import UserMaster from './components/UserSection/UserMaster/UserMaster';
import GroupMaster from './components/UserSection/GroupMaster/GroupMaster';
import GroupMenu from './components/UserSection/GroupMenuAccess/GroupMenu';
import {useState} from 'react';
import EventMaster from './components/Master/EventMaster/EventMaster';
import VenueMaster from './components/Master/VenueMaster/VenueMaster';

import UploadData from './components/Operation/UploadData/UploadData';

import DistrictMaster from './components/Master/DistrictMaster/DistrictMaster';
import CustodianMaster from './components/Master/CustodianMaster/CustodianMaster';
import PickupMasterReport from './components/Report/PickupMasterReport/PickupMasterReport';
import UploadDataReport from './components/Report/UploadDataReport/UploadDataReport';
import TrackingTrunk from './components/Operation/TrackingTrunk/TrackingTrunk';
import ForgetPassword from './components/UserSection/ForgetPassword/ForgetPassword';
import ResetForgetPassword from './components/UserSection/ResetForgetPassword/ResetForgetPassword';
import QRcode from './components/QRCode/QrCode';
import ImageStatus from './components/ImageStatus/ImageStatus';
/*import ImageUpload from './components/ImageUpload/ImageUpload';*/
import ResetForgetPassUser from './components/ResetForgetpassUser/ResetForgetpassUser';
import UserLocationHistory from './components/Report/UserLocationHistory/UserLocationHistory';
import Footer from './components/Layout/FooterComponent';
import TrackMatePrivacyPolicy from './components/TrackMatePrivacyPolicy/TrackMatePrivacyPolicy';




export const App = () => {
    const [open, setOpen] = useState(true);
    const defaultTheme = createTheme();                                                                                                                    
    return (
        <div>
        <ThemeProvider theme={defaultTheme}>
            <Routes>
                <Route path='*' element={<PageNotFound />} />
                <Route path='/login' element={<SignIn />} />
                <Route path='/' element={<SignIn />} />
                    <Route path='/Images' element={<ImageStatus />} />
                    <Route path='/TrackMatePrivacyPolicy' element={<TrackMatePrivacyPolicy /> }/>
                <Route path='/QrCode' element={<QRcode />} />
           {/*     <Route path='/DownloadImage' element={<ImageUpload/> }/>*/}
                <Route path='/dashboard' element={<Protected setOpen={setOpen} open={open} Component={Dashboard} PageUrl='Dashboard' />} />
                <Route path='/forgetpassword' element={<ForgetPassword />} />
                <Route path='/ResetForgetPassword' element={<ResetForgetPassUser/> }/>


                {/*<Route path='/UpdateForgotPasswordUser' element={<ResetForgetPassword />} />*/}
                {/*UserSectionStart*/}
                <Route path='/usermaster' element={<Protected setOpen={setOpen} open={open} Component={UserMaster} PageUrl='UserMaster' />} />
                <Route path='/changepassword' element={<Protected setOpen={setOpen} open={open} Component={ChangePassword} PageUrl='ChangePassword' />} />
                <Route path='/resetpassword' element={<Protected setOpen={setOpen} open={open} Component={ResetPassword} PageUrl='ResetPassword' />} />
                <Route path='/groupmaster' element={<Protected setOpen={setOpen} open={open} Component={GroupMaster} PageUrl='GroupMaster' />} />
                <Route path='/groupmenuaccess' element={<Protected setOpen={setOpen} open={open} Component={GroupMenu} PageUrl='GroupMenuAccess' />} />
                {/*UserSectionEnd*/}

                <Route path='/eventmaster' element={<Protected setOpen={setOpen} open={open} Component={EventMaster} PageUrl='EventMaster' />} />
                <Route path='/venuemaster' element={<Protected setOpen={setOpen} open={open} Component={VenueMaster} PageUrl='VenueMaster' />} />
                <Route path='/uploadData' element={<Protected setOpen={setOpen} open={open} Component={UploadData} PageUrl='UploadData' />} />
                <Route path='/CustodianMaster' element={<Protected setOpen={setOpen} open={open} Component={CustodianMaster} PageUrl='CustodianMaster' />} />
                <Route path='/DistrictMaster' element={<Protected setOpen={setOpen} open={open} Component={DistrictMaster} PageUrl='DistrictMaster' />} />
                <Route path='/PickupMasterReport' element={<Protected setOpen={setOpen} open={open} Component={PickupMasterReport} PageUrl='PickupMasterReport' />} />
                <Route path='/UploadDataReport' element={<Protected setOpen={setOpen} open={open} Component={UploadDataReport} PageUrl='UploadDataReport' />} />
                <Route path='/TrackingTrunk' element={<Protected setOpen={setOpen} open={open} Component={TrackingTrunk} PageUrl='TrackingTrunk' />} />
                <Route path='/UserLocationHistory' element={<Protected setOpen={setOpen} open={open} Component={UserLocationHistory} PageUrl='UserLocationHistory'/> }/>
            </Routes>
        
            </ThemeProvider>
    
       
        </div>
    );

}
